import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SoundProvider } from './contexts/SoundContext';
import ParticlesBackground from './components/ParticlesBackground';
import CalculatorPage from './components/CalculatorPage';
import PilotCalculatorPage from './components/PilotCalculatorPage';
import ModCalculatorPage from './components/ModCalculatorPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import CheckMyStats from './pages/CheckMyStats';
import LegendarySkins from './pages/LegendarySkins';
import AdminApp from './admin/AdminApp';

function AppContent() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CalculatorPage />} />
        <Route path="/pilot-upgrade-calculator" element={<PilotCalculatorPage />} />
        <Route path="/mod-calculator" element={<ModCalculatorPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/my-stats" element={<CheckMyStats />} />
        <Route path="/legendary-skins" element={<LegendarySkins />} />
        <Route path="/admin/*" element={<AdminApp />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <SoundProvider>
          <AppContent />
        </SoundProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
